import { render, staticRenderFns } from "./AuthDialog.vue?vue&type=template&id=6c62f00b"
import script from "./AuthDialog.vue?vue&type=script&lang=js"
export * from "./AuthDialog.vue?vue&type=script&lang=js"
import style0 from "./AuthDialog.vue?vue&type=style&index=0&id=6c62f00b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports